<template>
  <div class="mydialog big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="page_title">病历记录</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox">
              <div class="item">
                <span>患者姓名</span>
                <el-input placeholder="请输入"
                          v-model="patient_name"
                          style="width:120px;margin-left:12px"
                          @input="search"
                          clearable></el-input>
              </div>
              <div class="item">
                <span>医生姓名</span>
                <el-input placeholder="请输入"
                          v-model="doctor_name"
                          style="width:120px;margin-left:12px"
                          clearable
                          @input="search"></el-input>
              </div>
              <div class="item">
                <span>医生手机号</span>
                <el-input placeholder="请输入"
                          v-model="doctor_phone"
                          style="width:120px;margin-left:12px"
                          clearable
                          @input="search"></el-input>
              </div>

              <div class="item">
                <span>开方时间</span>
                <el-date-picker v-model="date"
                                type="daterange"
                                range-separator="~"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                clearable
                                style="width:264px;margin-left:12px"
                                @change="search"></el-date-picker>
                <el-button type="info"
                           style="background-color:#eceff2;;color:#747981;margin-left:10px"
                           @click="search">查询</el-button>
              </div>
              <div class="item">
                <span style="margin-right:10px">是否测试医生</span>
                <el-radio-group v-model="is_test"
                                @change="search">
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div style="border: solid 1px #c9cbd6;">
              <el-table ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%;min-width:1000px;"
                        :header-cell-style="{background:'#F5F5F5'}">
                <el-table-column label="患者姓名"
                                 prop="user_name"></el-table-column>

                <el-table-column label="开方时间"
                                 prop="create_time"></el-table-column>
                <el-table-column label="主述"
                                 prop="chief_complaint"></el-table-column>
                <el-table-column label="诊断"
                                 prop="diagnosis"></el-table-column>
                <el-table-column label="科室"
                                 prop="department_name"></el-table-column>

                <el-table-column label="医生姓名">
                  <template slot-scope="scope">
                    <span @click="showDocMsg(scope.row.doctor_id)"
                          style="cursor:pointer">{{scope.row.doctor_name}}</span>
                  </template>

                </el-table-column>
                <el-table-column label="职称"
                                 prop="title"></el-table-column>
                <el-table-column label="手机号"
                                 prop="phone"></el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text"
                               @click="toDetail(scope.row.pre_id)">查看病历</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"
                             :current-page="currentPage"
                             :page-sizes="[10, 20, 50, 100]"
                             :page-size="10"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="totalNum"
                             style="margin:20px 0"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import yewu from '../../../api/yewu';
import platform from '../../../api/platform';
import moment from 'moment';
import Template from '../../template/Template.vue';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  components: { Template },
  data() {
    return {
      date: [],
      totalNum: 0,
      patient_name: '',
      doctor_name: '',
      doctor_phone: '',
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      is_test: 2,
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  components: {
    DocMsg
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        patient_name: this.patient_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        patient_id: 0,
        start_time: '',
        end_time: '',
        is_test: this.is_test
      };
      if (this.date && this.date.length > 0) {
        data.start_time = moment(this.date[0]).format('YYYY-MM-DD');
        data.end_time = moment(this.date[1]).format('YYYY-MM-DD');
      }
      yewu.casehistoryList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = platform.timestampToTime(item.create_time);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },

    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    toDetail(pre_id) {
      this.$router.push({
        path: 'binglidetail',
        query: {
          pre_id
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 1px 20px;
  .searchbox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .item {
      margin-right: 30px;
      margin-top: 24px;
      display: flex;
      align-items: center;
    }
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
</style>
